import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { forwardRef } from 'react';

import { Box } from '@opendoor/bricks-next';

type BoxPropsWithoutRef = ComponentPropsWithoutRef<typeof Box>;
export type ListItemProps = Omit<BoxPropsWithoutRef, 'tag'> & { inline?: boolean };

export const ListItem = forwardRef<ElementRef<typeof Box>, ListItemProps>(
  ({ inline, '$platform-web': platformWeb, display, ...props }, ref) => (
    <Box
      ref={ref}
      tag="li"
      height="auto"
      $platform-web={{
        display: display ?? (inline ? 'inline-list-item' : 'list-item'),
        breakInside: 'avoid',
        ...platformWeb,
      }}
      {...props}
    />
  ),
);

ListItem.displayName = 'ListItem';
